var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLoadingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 23,
    viewBox: "0 0 67 23",
    width: 67,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.55556 16.6667c-3.06389 0-5.55556-2.4917-5.55556-5.5556 0-3.06388 2.49167-5.55554 5.55556-5.55554 3.06388 0 5.55554 2.49166 5.55554 5.55554 0 3.0639-2.49166 5.5556-5.55554 5.5556zm0-8.33337c-1.53056 0-2.77778 1.24723-2.77778 2.77777 0 1.5333 1.24722 2.7778 2.77778 2.7778 1.53055 0 2.77777-1.2445 2.77777-2.7778 0-1.53054-1.24722-2.77777-2.77777-2.77777z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.1111 16.6667c-3.0639 0-5.5555-2.4917-5.5555-5.5556 0-3.06388 2.4916-5.55554 5.5555-5.55554s5.5556 2.49166 5.5556 5.55554c0 3.0639-2.4917 5.5556-5.5556 5.5556zm0-8.33337c-1.5333 0-2.7778 1.24723-2.7778 2.77777 0 1.5333 1.2445 2.7778 2.7778 2.7778s2.7778-1.2445 2.7778-2.7778c0-1.53054-1.2445-2.77777-2.7778-2.77777z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.8333 18.0556c-3.8305 0-6.9444-3.1167-6.9444-6.9445 0-3.83054 3.1139-6.94443 6.9444-6.94443 3.8306 0 6.9445 3.11389 6.9445 6.94443 0 3.8278-3.1139 6.9445-6.9445 6.9445zm0-11.11116c-2.2972 0-4.1666 1.86945-4.1666 4.16666 0 2.2972 1.8694 4.1667 4.1666 4.1667 2.2973 0 4.1667-1.8695 4.1667-4.1667 0-2.29721-1.8694-4.16666-4.1667-4.16666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.6667 22.2222c-6.1278 0-11.1111-4.9833-11.1111-11.1111 0-6.12777 4.9833-11.1111 11.1111-11.1111 6.1277 0 11.1111 4.98333 11.1111 11.1111 0 6.1278-4.9834 11.1111-11.1111 11.1111zm0-19.44442c-4.5945 0-8.3334 3.73889-8.3334 8.33332 0 4.5945 3.7389 8.3333 8.3334 8.3333 4.5944 0 8.3333-3.7388 8.3333-8.3333 0-4.59443-3.7389-8.33332-8.3333-8.33332z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoadingWhite);
export default __webpack_public_path__ + "static/media/ico_loading_white.d10b05ceeaa97056331a930d582154b7.svg";
export { ForwardRef as ReactComponent };